module.exports = __webpack_public_path__ + "img/code.3dc594b4.png";